export default class DeleteSolutionMinorVersionContentError extends Error {
}
